import classes from './ResultsTableRedundancy.module.css'
import React, { Fragment, useContext, useEffect, useState } from "react";
import { InputDataContext } from '../../shared/contexts/InputDataContext';
import { OutputDataContext } from '../../App';
import { formatDate, currencyFormatter } from '../../utilities/Formatters';

const ResultsTable = (props) => {
    const { inputsRef} = useContext(InputDataContext);
    const { outputDataRef } = useContext(OutputDataContext);
    console.log('outputs', outputDataRef.current)


    const status = props.status
    const spa_years = inputsRef.current.spa_age['years']
    const spa_months = inputsRef.current.spa_age['months']
    const spa_age = spa_years + spa_months / 12
    const npa_mapper = {
        '1995 Section' : status === 'Neither of these' ? 60 : 55,
        '2008 Section' : 65, 
        '2015' : Math.max(spa_age, 65)
    }
    const legacy_scheme = inputsRef.current.legacyScheme
    const legacy_npa = npa_mapper[legacy_scheme]
    const reformed_npa = npa_mapper['2015']
    const ret_age = inputsRef.current.retirementDate
    const severancePayment = inputsRef.current.severancePayment
    // const LumpSum = inputsRef.current.LumpSum

    // const pen_after_erf_legacy = outputDataRef.current.pension.choose_legacy.old + outputDataRef.current.pension.choose_legacy.new
    // const pen_after_erf_care = outputDataRef.current.pension.choose_reformed.old + outputDataRef.current.pension.choose_reformed.new

    // const pen_before_erf_legacy = outputDataRef.current.pension.choose_legacy.old / outputDataRef.current['ERF legacy 2022'] + outputDataRef.current.pension.choose_legacy.new / outputDataRef.current['ERF care']
    // const pen_before_erf_care = outputDataRef.current.pension.choose_reformed.old / outputDataRef.current['ERF legacy'] + outputDataRef.current.pension.choose_reformed.new / outputDataRef.current['ERF care']

    // const unearned_pen_legacy = pen_before_erf_legacy - pen_after_erf_legacy
    // const unearned_pen_care = pen_before_erf_care - pen_after_erf_care
    
    // const unreduced_cost_legacy = outputDataRef.current['CER_Factor'] * unearned_pen_legacy
    // const unreduced_cost_care = outputDataRef.current['CER_Factor'] * unearned_pen_care

    // const prop_cost_met_legacy = Number(severancePayment) / unreduced_cost_legacy
    // const prop_cost_met_care = Number(severancePayment) / unreduced_cost_care

    // const pen_available_legacy = pen_after_erf_legacy + unearned_pen_legacy * prop_cost_met_legacy
    // const pen_available_care = pen_after_erf_care + unearned_pen_care * prop_cost_met_care

    const prop_cost_met_legacy = outputDataRef.current['Total_Cost_Legacy'] === 0 ? 1 : Math.max(0, Math.min(1, Number(severancePayment) / outputDataRef.current['Total_Cost_Legacy']))
    const prop_cost_met_care = outputDataRef.current['Total_Cost_Care'] === 0 ? 1 : Math.max(0, Math.min(1, Number(severancePayment) / outputDataRef.current['Total_Cost_Care']))

    const pen_available_legacy = outputDataRef.current['After_ERF_Legacy'] + prop_cost_met_legacy * Math.max(0, (outputDataRef.current['Before_ERF_Legacy'] - outputDataRef.current['After_ERF_Legacy']))
    const pen_available_care = outputDataRef.current['After_ERF_Care'] + prop_cost_met_care * Math.max(0, (outputDataRef.current['Before_ERF_Care'] - outputDataRef.current['After_ERF_Care']))
    
    const ls_available_legacy = outputDataRef.current['After_ERF_Legacy_ls'] + prop_cost_met_legacy * Math.max(0, (outputDataRef.current['Before_ERF_Legacy_ls'] - outputDataRef.current['After_ERF_Legacy_ls']))
    const ls_available_care = outputDataRef.current['After_ERF_Care_ls'] + prop_cost_met_care * Math.max(0, (outputDataRef.current['Before_ERF_Care_ls'] - outputDataRef.current['After_ERF_Care_ls']))

    const additional_cont_legacy = outputDataRef.current['Total_Cost_Legacy'] - (Number(severancePayment))
    const additional_cont_care = outputDataRef.current['Total_Cost_Care'] - (Number(severancePayment))
    
    const additional_cont_floor_legacy = Math.max(0, additional_cont_legacy)
    const additional_cont_floor_care = Math.max(0, additional_cont_care)

    let commentaryLegacy = "";
    let commentaryCare = "";

    // const member_spa = outputDataRef.current['spa_age']['years'] + outputDataRef.current['spa_age']['months'] / 12
    // const member_spa_date = outputDataRef.current['spa']

    // commentaryLegacy = `There is no reduction of early retirement and therefore no redundancy cost. ${member_age} ${member_spa} ${ret_age}`;
    // commentaryCare = `There is no reduction of early retirement and therefore no redundancy cost. ${member_ret_date} ${member_spa_date}`;

    // if (Number(member_age) >= Number(member_spa)) {
    if (ret_age >= outputDataRef.current['spa']) {
        commentaryLegacy = `There is no reduction for early retirement and therefore no redundancy cost.`;
    } else if (additional_cont_floor_legacy === 0) {
        commentaryLegacy = `The unreduced benefits can be 
        covered in full by the severance payment. 
        The remainder in excess of the 
        contribution is ${currencyFormatter(-additional_cont_legacy)}.`;
    } else {
        commentaryLegacy = `The unreduced benefits cannot be 
        covered in full by the severance payment. 
        An additional ${currencyFormatter(additional_cont_legacy)} would 
        be required to secure full unreduced benefits.`;
    }

    if (ret_age >= outputDataRef.current['spa']) {
        commentaryCare = `There is no reduction for early retirement and therefore no redundancy cost.`;
    } else if (additional_cont_floor_care === 0) {
        commentaryCare = `The unreduced benefits can be 
        covered in full by the severance payment. 
        The remainder in excess of the 
        contribution is ${currencyFormatter(-additional_cont_care)}.`;
    } else {
        commentaryCare = `The unreduced benefits cannot be 
        covered in full by the severance payment. 
        An additional ${currencyFormatter(additional_cont_care)} would 
        be required to secure full unreduced benefits.`;
    }
    
    const dummy_number = 100

    return(
<div className = {classes.results_table}> 

    {/* <h1 style = {{textAlign: 'center'}}> NHS England redundancy </h1> */}
    <p style = {{textAlign: 'center', fontSize: '1.6em'}}> Your choice of redundancy benefits at a glance </p>
    <p style = {{fontWeight: 'normal', fontSize: '1.2em'}}> 
        This section gives an illustrative view of how taking your NHS pension in connection with redundancy could affect your benefits. 
        It does not calculate any redundancy payment from your employer or confirm your eligibility for redundancy related pension terms. 
        Your actual terms will depend on your employer's policies and NHS Pension Scheme rules.
    </p>
    {/* <p> 
        On the next page, you can see your options in more detail. You can check how different decisions, like changing your retirement age or lump sum amount, can affect your pension benefits.
    </p> */}

    <div className = {classes.boxes_container}> 
            <div className= {classes.box}> 
            <h2> Based on </h2>
            <div className = {classes.based_on}>
            <div><p> Retirement Date: </p> <p> {formatDate(inputsRef.current.retirementDate)}</p> </div>

            <div><p> Lump sum payment from employer: </p> <p> {currencyFormatter(severancePayment)}</p> </div>

            {/* <div><p> Additional contribution towards unreduced benefits: </p> <p> {Number(LumpSum)}</p> </div> */}
            
            <div><p> Salary increase: </p> <p> {outputDataRef.current.salaryIncrease}%</p> </div>
            </div>
            </div>
        <div className = {classes.box + ' ' + classes.choose_option}> 
            <p>
                <span style = {{ fontSize: '1.2em'}}>Option A - Standard Benefits</span> 
                <br></br> 
                Choose {legacy_scheme} benefits for the remedy period 
            </p> 
        </div>
        <div></div>
        <div className = {classes.box + ' ' + classes.choose_option}> 
            <p>
                <span style = {{ fontSize: '1.2em'}}>Option B – Alternative Benefits</span> 
                <br></br> 
                Choose 2015 Scheme benefits for the remedy period
            </p>
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}> 
            <h2><b>Unreduced pension at retirement</b></h2>
            <br></br>
            <h2>Estimated yearly pension at retirement <b>before</b> any adjustment is applied to reflect early or late retirement relative to normal pension age. </h2>
        </div>
        <div className = {classes.box}> 
            <h2> Unreduced pension at retirement: </h2>
            <h1>  {currencyFormatter(
                outputDataRef.current['Before_ERF_Legacy']
            )}</h1>
        </div> 
        <div></div>
        <div className = {classes.box}> 
            <h2> Unreduced pension at retirement: </h2>
            <h1>  {currencyFormatter(
                outputDataRef.current['Before_ERF_Care']
            )}</h1>
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}> 
            <h2><b>Pension at retirement after adjustment for early or late retirement</b></h2>
            <br></br>
            <h2>Estimated yearly pension at retirement <b>after</b> any adjustment is applied to reflect payment beginning early or late relative to normal pension age.</h2>
        </div>
        <div className = {classes.box}> 
            {/* After ERF */}
            <h2> Pension at retirement after </h2>
            <h2> adjustment for early or late retirement: </h2>
            <h1>  {currencyFormatter(outputDataRef.current['After_ERF_Legacy'])}</h1>
            {/* <h1>  {currencyFormatter(pen_after_erf_legacy)}</h1> */}
        </div>
        <div></div>
        <div className = {classes.box}> 
            {/* After ERF */}
            <h2> Pension at retirement after </h2>
            <h2> adjustment for early or late retirement: </h2>
            <h1>  {currencyFormatter(outputDataRef.current['After_ERF_Care'])}</h1>
            {/* <h1>  {currencyFormatter(pen_after_erf_care)}</h1> */}
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}>
            <h2><b>Automatic lump sum at retirement</b></h2>
            <br></br> 
            <h2>Estimated one-off lump sum payable automatically at retirement (if applicable), <b>after</b> any adjustment is applied to reflect the payment being made early relative to normal pension age. No allowance is made for the option to exchange some of your pension for a tax free lump sum (pension commutation).</h2>
        </div>        
        <div className = {classes.box}> 
            {/* After ERF */}
            <h2> Automatic lump sum at retirement: </h2>
            <h1>  {currencyFormatter(outputDataRef.current['After_ERF_Legacy_ls'])}</h1>
            {/* <h1>  {currencyFormatter(outputDataRef.current['lump sum'].choose_legacy)}</h1> */}
        </div>
        <div></div>
        <div className = {classes.box}> 
            {/* After ERF */}
            <h2> Automatic lump sum at retirement: </h2>
            <h1>  {currencyFormatter(outputDataRef.current['After_ERF_Care_ls'])}</h1>
            {/* <h1>  {currencyFormatter(outputDataRef.current['lump sum'].choose_reformed)}</h1> */}
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}>
        <h2><b>Redundancy cost of unreduced benefits</b></h2>
        <br></br> 
        <h2>Estimated cost to provide the pension with no early retirement reduction under redundancy terms.</h2>
        </div> 
        {/* <div className = {classes.box}> 
            <h2> CER redundancy factor: </h2>
            <h1>  {outputDataRef.current['CER_Factor']}</h1>
        </div>
        <div></div>
        <div className = {classes.box}>
            <h2> CER redundancy factor: </h2>
            <h1>  {outputDataRef.current['CER_Factor']}</h1>
        </div> */}
        <div className = {classes.box}> 
            <h2> Redundancy cost of unreduced benefits: </h2>
            <h1>  {currencyFormatter(outputDataRef.current['Total_Cost_Legacy'])}</h1>
            {/* <h1>  {currencyFormatter(unreduced_cost_legacy)}</h1> */}
        </div>
        <div></div>
        
        <div className = {classes.box}> 
            <h2> Redundancy cost of unreduced benefits: </h2>
            <h1>  {currencyFormatter(outputDataRef.current['Total_Cost_Care'])}</h1>
            {/* <h1>  {currencyFormatter(unreduced_cost_care)}</h1> */}
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}>
            <h2><b>Additional contribution required</b></h2>
            <br></br> 
            <h2>Extra amount needed (if any) to secure the pension with no early retirement reduction, <b>in addition</b> to the lump sum payment from employer above.</h2>
        </div> 
        {/* {outputDataRef.current['Total_Cost_Legacy'] - (Number(severancePayment) + Number(LumpSum))  > 0 && ( */}
        <div className={classes.box}>
            <h2>Additional contribution required:</h2>
            <h1>
            {currencyFormatter(
                 additional_cont_floor_legacy
                //  Math.max(0, (unreduced_cost_legacy - (Number(severancePayment))))
            )}
            </h1>
        </div>
        {/* )} */}
        <div></div>
        {/* { (outputDataRef.current['Total_Cost_Care'] - (Number(severancePayment) + Number(LumpSum)) ) > 0 && ( */}
        <div className={classes.box}>
            <h2>Additional contribution required:</h2>
            <h1>
            {currencyFormatter(
                additional_cont_floor_care
                // Math.max(0, (unreduced_cost_care - (Number(severancePayment))))
            )}
            </h1>
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}>
            <h2><b>Redundancy pension available</b></h2>
            <br></br> 
            <h2>Estimated yearly pension payable under redundancy terms, based on the extent that the lump sum payment from employer can cover the cost of removing any applicable early retirement reduction.</h2>
        </div>        
        {/* )} */}
        <div className = {classes.box}> 
            <h2> Redundancy pension available: </h2>
            <h1>  {currencyFormatter(pen_available_legacy)}</h1>
        </div>
        <div></div>
        
        <div className = {classes.box}> 
            <h2> Redundancy pension available: </h2>
            <h1>  {currencyFormatter(pen_available_care)}</h1>
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}>
            <h2><b>Redundancy lump sum available</b></h2>
            <br></br> 
            <h2>Estimated one-off lump sum payable at retirement under redundancy terms, based on the extent that the lump sum payment from employer can cover the cost of removing any applicable early retirement reduction to benefits.</h2>
        </div>        
        <div className = {classes.box}> 
            <h2> Redundancy lump sum available: </h2>
            <h1>  {currencyFormatter(ls_available_legacy)}</h1>
        </div>
        <div></div>
        
        <div className = {classes.box}> 
            <h2> Redundancy lump sum available: </h2>
            <h1>  {currencyFormatter(ls_available_care)}</h1>
        </div>
        <div className = {classes.box + ' ' + classes.fullWidthHeader}>
            <h2><b>Summary</b></h2>
        </div>                
        <div className = {classes.box + ' ' + classes.choose_option}>
            <h2>{commentaryLegacy}</h2>
        </div>       
        <div></div>
        
        <div className = {classes.box + ' ' + classes.choose_option}>
            <h2>{commentaryCare}</h2>
        </div>
    </div>
 <br></br>
 {/* <p style = {{fontWeight: 'normal', fontSize: '1.2em'}}>
    Any pension benefits you built up before or after the remedy period aren’t affected by your choice, but they are included in the totals shown above. 
 </p> */}
 <p style = {{fontWeight: 'normal', fontSize: '1.2em'}}>
    The above illustrations assume that redundancy occurs on the same date as retirement and show figures before allowance for commutation. 
    If you are employed on Agenda for Change terms then you may be entitled to unreduced benefits with your employer covering any additional costs required for these.
 </p>
</div>
    )
}

export default ResultsTable

